"use client";

// src/components/default/circle-x.tsx
import * as React from "react";
import { useUID } from "@stepstone-genesis/uid-library";
import { systemForwardRef } from "@stepstone-genesis/system";
import {
  IconContainer
} from "@stepstone-genesis/icon-containers";
var CircleXIcon = systemForwardRef(
  function IconWrapper({ title, id, display, size, color, ...rest }, ref) {
    const identifier = useUID();
    const titleId = title ? `CircleXIcon-${id != null ? id : identifier}` : void 0;
    const role = title ? "img" : "presentation";
    const componentName = `CircleXIcon`;
    return /* @__PURE__ */ React.createElement(
      IconContainer,
      {
        ...rest,
        display,
        size,
        color,
        ref
      },
      /* @__PURE__ */ React.createElement(
        "svg",
        {
          "data-genesis-element": componentName,
          role,
          width: "100%",
          height: "100%",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          "aria-labelledby": titleId
        },
        title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
        /* @__PURE__ */ React.createElement(
          "path",
          {
            fill: "currentColor",
            d: "M9.99982 10.7741L12.5607 13.335C12.6761 13.4504 12.8038 13.5059 12.9437 13.5016C13.0837 13.4974 13.214 13.4349 13.3347 13.3141C13.4555 13.1934 13.5158 13.0644 13.5158 12.9271C13.5158 12.7899 13.4555 12.6612 13.3347 12.541L10.7738 9.98964L13.3347 7.43825C13.4501 7.32347 13.5092 7.1961 13.5118 7.05614C13.5145 6.9162 13.4555 6.78587 13.3347 6.66514C13.214 6.54441 13.085 6.48404 12.9477 6.48404C12.8105 6.48404 12.6815 6.54441 12.5607 6.66514L9.99982 9.22604L7.4389 6.66514C7.32352 6.54976 7.19933 6.49073 7.06632 6.48806C6.93332 6.48538 6.80646 6.54441 6.68573 6.66514C6.565 6.78587 6.50463 6.91487 6.50463 7.05214C6.50463 7.18942 6.56439 7.31842 6.68392 7.43914L9.2258 10.0001L6.6649 12.561C6.54951 12.6764 6.49396 12.8005 6.49823 12.9336C6.5025 13.0666 6.565 13.1934 6.68573 13.3141C6.80646 13.4349 6.93546 13.4952 7.07273 13.4952C7.21001 13.4952 7.33841 13.4355 7.45794 13.316L9.99982 10.7741ZM10.007 17.5834C8.96374 17.5834 7.98124 17.386 7.05946 16.9913C6.13767 16.5966 5.33085 16.0534 4.639 15.3619C3.94714 14.6704 3.40376 13.8642 3.00886 12.9434C2.61396 12.0227 2.4165 11.0388 2.4165 9.99192C2.4165 8.945 2.61387 7.96412 3.00859 7.04929C3.40331 6.13444 3.94643 5.3311 4.63796 4.63925C5.3295 3.94739 6.13566 3.40401 7.05644 3.0091C7.97722 2.6142 8.96106 2.41675 10.008 2.41675C11.0549 2.41675 12.0358 2.61411 12.9506 3.00883C13.8654 3.40355 14.6688 3.94668 15.3606 4.63821C16.0525 5.32975 16.5959 6.13428 16.9908 7.05181C17.3857 7.96934 17.5831 8.94971 17.5831 9.99292C17.5831 11.0361 17.3858 12.0186 16.991 12.9404C16.5963 13.8622 16.0532 14.669 15.3617 15.3609C14.6701 16.0527 13.8656 16.5961 12.9481 16.991C12.0305 17.3859 11.0502 17.5834 10.007 17.5834ZM9.99982 16.5001C11.8054 16.5001 13.3401 15.8681 14.604 14.6042C15.8679 13.3403 16.4998 11.8056 16.4998 10.0001C16.4998 8.19451 15.8679 6.65978 14.604 5.39589C13.3401 4.13201 11.8054 3.50006 9.99982 3.50006C8.19426 3.50006 6.65954 4.13201 5.39565 5.39589C4.13176 6.65978 3.49982 8.19451 3.49982 10.0001C3.49982 11.8056 4.13176 13.3403 5.39565 14.6042C6.65954 15.8681 8.19426 16.5001 9.99982 16.5001Z"
          }
        )
      )
    );
  }
);
export {
  CircleXIcon
};
